import CssBaseline from '@mui/material/CssBaseline'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React from 'react'

import ImpersonationBanner from 'components/impersonation/ImpersonationBanner'
import { useImpersonationSession } from 'providers/ImpersonationProvider'

const Root = styled('div')`
  display: flex;
  height: 100%;
  width: 100%;
`

// minWidth 0 lets the page shrink back after a zoom out; without it a data grid's pixel column widths hold it wide.
const AppContent = styled('div')(({ sx }) => ({
  flex: '1',
  minWidth: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  ...sx,
}))

// The app header is a position:fixed AppBar anchored to the viewport, which would overlap the
// impersonation banner. While impersonating, `transform` makes this element the containing block
// for that fixed AppBar, re-anchoring it below the banner so the whole app shifts down as a unit —
// no per-page top offsets to chase. Sticky sub-bars stay relative to their scroll container, and
// MUI dialogs/menus portal to <body>, so both are unaffected.
const AppShift = styled('div', { shouldForwardProp: prop => prop !== 'shift' })(({ shift }) => ({
  flex: '1',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  ...(shift ? { transform: 'translateZ(0)' } : {}),
}))

const AppWrapper = ({ children }) => {
  const { isImpersonating } = useImpersonationSession()
  return (
    <Root>
      <CssBaseline />
      <AppContent>
        <ImpersonationBanner />
        <AppShift shift={isImpersonating}>{children}</AppShift>
      </AppContent>
    </Root>
  )
}

AppWrapper.propTypes = {
  children: PropTypes.object,
}

export default AppWrapper
